import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=d8b482a6"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports